import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4787965b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787965b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4787965b')) {
      api.createRecord('4787965b', component.options)
    } else {
      api.reload('4787965b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4787965b&scoped=true&", function () {
      api.rerender('4787965b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/orders/index.vue"
export default component.exports